import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const createStory = (formData) =>
	Http.post('/stories/store', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const getStories = (params = {}) =>
	Http.get(`/stories/fetch${serialize(params)}`)
